export default "__VITE_ASSET__BGQ2aEGb__"